import { IUser } from "./users.model";


export class SetUser {
  static readonly type: string = '[Users] Set';

  constructor(public user: IUser, public patchNewState: boolean = true) {}
}

export class SetAllUsers {
  static readonly type: string = '[Users] SetAll';

  constructor(public users: IUser[]) {}
}

export class RemoveUser {
  static readonly type: string = '[Users] Remove';

  constructor(public userId: string) {}
}

export class SetMaxUsers {
  static readonly type: string = '[Users] SetMaxUsers';

  constructor(public maxUsers: number) {}
}

export class SetDataLoaded {
  static readonly type: string = '[Users] SetDataLoaded';

  constructor(public loading: boolean) {}
}
